import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Avatar, Text, Loading, Image } from '../../kit';
import { MenuItem } from './MenuItem';
import { getImage } from '../../../utils';
import { NavItem } from '../../../models';
import { useSelector } from '../../../hooks';
import { userRoles, TEMPLATE_1, TEMPLATE_2, TEMPLATE_3, TEMPLATE_4 } from '../../../config';

export default function Nav(props) {
  const [navItems, setNavItems] = useState([
    new NavItem('محصولات', 'bag-16', '/products', userRoles.NORMAL_USER, [
      TEMPLATE_1, TEMPLATE_4
    ]),
    new NavItem('آگهی ها', 'bag-16', '/products', userRoles.NORMAL_USER, [
      TEMPLATE_2,
    ]),
    new NavItem(
      'محصولات رستوران',
      'shop-2',
      '/restaurant',
      userRoles.NORMAL_USER,
      [TEMPLATE_3]
    ),
    new NavItem('تنظیمات', 'gear', '/settings', userRoles.NORMAL_USER, []),
    new NavItem(
      'ایجاد سریع فاکتور',
      'recipe-create',
      '/invoice/quick-create',
      userRoles.NORMAL_USER,
      []
    ),
    new NavItem(
      'فاکتور ها',
      'recipe',
      '/invoice/list',
      userRoles.NORMAL_USER,
      []
    ),
    new NavItem(
      'فروش من',
      'users-wm',
      '/requests/direct-requests',
      userRoles.NORMAL_USER,
      [TEMPLATE_1, TEMPLATE_3, TEMPLATE_4]
    ),
    new NavItem(
      'سایت شخصی',
      'pc-monitor',
      '/personal-site',
      userRoles.SITE_OWNER,
      []
    ),
    new NavItem(
      'لیست مشتریان',
      'multiple-11',
      '/customers',
      userRoles.NORMAL_USER,
      []
    ),
  ]);
  const business = useSelector('profile.data.business');
  const { children, route, template } = props;

  useEffect(() => {
    if (!business.sites.length) {
      setNavItems(
        navItems.filter(
          ({ accessibleFor }) => accessibleFor < userRoles.SITE_OWNER
        )
      );
    }
  }, []);

  return (
    <div className="container p-0 overflow-hidden">
      <div className="row">
        <div className="col-3">
          <div className="p-3 bg-Primary min-height-100vh h-100 w-100  position-relative">
            {business ? (
              <Link to="/" className="d-block">
                <div className="d-flex flex-row mb-3 bb-lighterGray pb-3">
                  <Avatar
                    src={
                      getImage(business?.avatar?.hash) ||
                      '/images/imagePlaceholder.png'
                    }
                  />
                  <div className="flex-start-around flex-column mx-2">
                    <Text color="primaryText" size="xs">
                      خوش آمدید
                    </Text>
                    <Text color="white" size="mdb">
                      {business.name}
                    </Text>
                  </div>
                </div>
              </Link>
            ) : (
              <Loading />
            )}
            {navItems.map(({ title, icon, href, templates }, i) => {
              const shouldRender =
                templates.includes(template) ||
                templates.length === 0 ||
                process.env.NODE_ENV === 'development';

              return shouldRender ? (
                <MenuItem
                  key={i}
                  active={
                    !route.indexOf(href) && (href.slice(1) || !route.slice(1))
                  }
                  title={title}
                  iconName={icon}
                  href={href}
                />
              ) : null;
            })}
            <div className="position-absolute bottom-0 right-0 left-0 p-2 w-100">
              <div className="flex-center-center bt-lighterGray mt-2 h-3">
                <Image
                  className="w-2 h-2 rounded-circle mx-2 bg-white"
                  src="/images/raw-logo.jpeg"
                />
                <Text color="white"  size="mlg" className="mx-2">
                  Version 1.0.0
                </Text>
              </div>
            </div>
          </div>
        </div>
        <div className="col-9 p-0 position-inherit">{children}</div>
      </div>
    </div>
  );
}
